import { render, staticRenderFns } from "./proposal-detail-to-print.vue?vue&type=template&id=ef5a7f40&scoped=true&"
import script from "./proposal-detail-to-print.vue?vue&type=script&lang=ts&"
export * from "./proposal-detail-to-print.vue?vue&type=script&lang=ts&"
import style0 from "./proposal-detail-to-print.vue?vue&type=style&index=0&id=ef5a7f40&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef5a7f40",
  null
  
)

export default component.exports